var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-button",
        {
          staticStyle: { "margin-bottom": "10px" },
          attrs: { type: "primary", size: "small", icon: "el-icon-back" },
          on: {
            click: function($event) {
              return _vm.$router.back(-1)
            }
          }
        },
        [_vm._v("返回")]
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.newTableData,
            border: "",
            stripe: "",
            "header-cell-style": { background: "#f5f7fa" }
          }
        },
        [
          _c("el-table-column", {
            attrs: { align: "center", prop: "i", label: "序号", width: "50" }
          }),
          _c("el-table-column", {
            attrs: { align: "center", prop: "templateName", label: "模版名称" }
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "templateStatus_name",
              label: "模版状态"
            }
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "notaryStatus_name",
              label: "公证开通状态"
            }
          }),
          _c("el-table-column", {
            attrs: { align: "center", prop: "createTime", label: "创建时间" }
          }),
          _c("el-table-column", {
            attrs: { align: "center", prop: "updateTime", label: "更新时间" }
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              fixed: "right",
              label: "操作",
              width: "180"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.openDetails(scope.row.id)
                          }
                        }
                      },
                      [_vm._v("查看")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("TemDetails", {
        ref: "temDetails",
        on: {
          updateList: function($event) {
            return _vm.getList(_vm.$route.query.busiTemplateId)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }